c<template>
  <div class="debate-container">
    <div class="turn-container" v-for="turn in debate.debate" :key="turn.index">
      <div v-if="turn.role === 'Challenger'" class="challenger">
        <div v-for="(line, index) in turn.lines" :key="index">
          {{line}}
        </div>
      </div>
      <div v-else class="defender">
        <div v-for="(line, index) in turn.lines" :key="index">
          {{line}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import debate from './debates/DebateA2Colors'

  export default {
    name: 'Debate A2 Color',
    data() {
      return {
        debate
      }
    },
    methods: {
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .debate-container {
    font-family: serif;
    font-size: 18px;
  }
  .challenger {
    width:60%;
  }
  .defender {
    width:60%;
    margin-left:40%;
  }
  .challenger, .defender {
    margin-top: 20px;
    text-align: left;
    background-color:wheat;
    padding:10px 20px;
    border-radius: 10px;
  }
</style>
